var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-info.d1ef1457.png","uri@3x": __webpack_public_path__ + "icon-info.b7c47ff3.png","uri@2x": __webpack_public_path__ + "icon-info.669c4404.png",
    width: 40,
    height: 40
});